<template>
    <SimpleDataTable :headers="headers" :items="items" hide-actions>
        <template v-slot:name="props">
            <router-link
                :to="{ name: 'dashboardDetail', params: { api: props.item.api_id }}"
                class="api-name"
            >
                {{ props.item.api_name }}
            </router-link>
        </template>
        <template v-slot:freeRemain="props">
            {{ getFreeRemain(props.item) }}
        </template>
        <template v-slot:action="props">
            <a @click="openApiPricing(props.item)">{{ $t('buyMore') }}</a>
        </template>
    </SimpleDataTable>
</template>
<script>
import SimpleDataTable from '@/modules/fptai/components/SimpleDataTable'

export default {
    name: 'DataTable',
    components: { SimpleDataTable },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        headers () {
            let currentProjectType = this.$store.getters.currentProjectType
            return this.$appService.correctHeaders([
                {
                    text: 'API',
                    value: 'name',
                    type: 'custom'
                },
                {
                    text: this.$t('requests'),
                    value: 'requests'
                },
                {
                    text: this.$t('requestsError'),
                    value: 'error_requests'
                },
                {
                    text: this.$t('freeRemain'),
                    value: 'freeRemain',
                    type: 'custom',
                    visible: currentProjectType === this.$const.projectType.PREPAID
                },
                {
                    text: this.$t('paidRemain'),
                    value: 'paidRemain',
                    $value: item => {
                        let result = ''
                        if (item.usage && item.usage.paid) {
                            if (isNaN(item.usage.paid.remaining)) {
                                result = item.usage.paid.remaining
                            } else {
                                result = Math.max(0, Number(item.usage.paid.remaining))
                            }
                        }
                        return this.$filters.formatNumber(result)
                    }
                },
                {
                    text: this.$t('unit'),
                    value: 'unit',
                    $value: item => this.$t(item.unit.toLowerCase())
                },
                {
                    text: this.$t('action'),
                    value: 'action',
                    type: 'custom',
                    visible: currentProjectType === this.$const.projectType.PREPAID
                }
            ])
        }
    },
    methods: {
        getFreeRemain (item) {
            if (!item.usage.free) {
                return 0
            }
            return (
                item.usage.free.remaining
            )
        },
        openApiPricing (item) {
            this.$emit('open-api-pricing', {
                apiCode: item.api_id,
                apiName: item.api_name
            })
        }
    }
}
</script>

<style scoped>
.api-name {
    font-weight: bold;
    text-decoration: none;
}
</style>
